// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class InboundControllerStatusUpdateResponse {
    static getAttributeTypeMap() {
        return InboundControllerStatusUpdateResponse.attributeTypeMap;
    }
}
InboundControllerStatusUpdateResponse.discriminator = undefined;
InboundControllerStatusUpdateResponse.additionalProperties = false;
InboundControllerStatusUpdateResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=inboundControllerStatusUpdateResponse.js.map